import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth';
import { firstAllowedSettingsPath } from './settingsTabs';

/**
 * `/settings` 索引重定向：
 *   进入 /settings 时跳到「该用户有权限的第一个标签」。
 *   超管 → 用户管理；仅 dict:manage（如 HQ_ADMIN）→ 项目类型。
 *
 * 若一个权限都没有，返回 null —— 由 SystemSettingsPage 渲染「无权限」提示。
 */
export default function SettingsIndexRedirect() {
  const hasPermission = useAuthStore((s) => s.hasPermission);
  const to = firstAllowedSettingsPath(hasPermission);
  if (!to) return null;
  return <Navigate to={to} replace />;
}
